<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <div class="qi-content">
        <header style="display: flex; justify-content: space-between; align-items: center;">
          <h1>Filiais de Oferta</h1>
          <b style="padding: 7.5px 15px; border-radius: 70px; background-color: #FFF888;">
            <div style="display: flex">
              <span
                style="font-size: 15px; margin-top: 2.35px; margin-right: 7.5px;"
                class="material-icons"
              >
                dashboard
              </span>
              <span>
                SIMULAÇÃO
              </span>
            </div>
          </b>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row>
          <SelectedCourseBoxSimulate></SelectedCourseBoxSimulate>
          <vs-col>
            <vs-row v-if="offers">
              <vs-col
                v-for="(offersInBranch, branch) in offers"
                :key="branch"
              >
                <vs-card style="box-shadow: 0px 0px 2px 1px #888888;">
                  <vs-row vs-align="center">
                    <vs-col vs-w="12">
                      <vs-row>
                        <h3>
                          {{ branch }}
                        </h3>
                      </vs-row>
                    </vs-col>
                    <vs-col vs-w="12">
                      <vs-row>
                        <vs-col
                          style="padding: 0;"
                          v-for="offerData in offersInBranch"
                          :key="offerData.CODTURNO"
                          :vs-w="offerData.MODALIDADE === 'D' ? 12 : 3"
                          vs-xs="12"
                        >
                          <vs-button
                            :style="offerData.MODALIDADE === 'D' ? 'width:50%;margin: 0 25%; 0 25%;' : 'width:95%;margin: 0.85% 2.5%; 0 2.5%;'"
                            @click="selectOffer(offerData)"
                          >
                            {{ formatShift(offerData) }}
                          </vs-button>
                        </vs-col>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
            </vs-row>
            <vs-alert
              title="Não há ofertas"
              class="margin"
              color="danger"
              v-else-if="error"
            >
              {{ error }}
            </vs-alert>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import SelectedCourseBoxSimulate from "../components/SelectedCourseBoxSimulate.vue";
import CoursesService from "../services/courses";
import { bus } from "../main";
import {
  getStepsInformation,
  updateStepsInformation,
} from "../helpers/storage";
import { sortListByAttribute } from "../helpers";

export default {
  name: "Branches",
  components: {
    SelectedCourseBoxSimulate,
  },
  data: () => ({
    offers: null,
    selectedCourse: null,
    error: false,
    offerSelected: null,
  }),
  created() {
    const stepsData = getStepsInformation();
    if (stepsData.courseSimulate) this.selectedCourse = stepsData.courseSimulate;
  },
  mounted() {
    this.$vs.loading({
      color: "danger",
    });
    bus.$emit("updateSteps", 1);
    new CoursesService()
      .getOffers(
        this.selectedCourse.CODCURSO,
        this.selectedCourse.IDCLASSIFICACAO
      )
      .then(({ data }) => {
        if (!Array.isArray(data)) {
          this.selectOffer(data);
          return;
        }
        this.offers = sortListByAttribute(data, "FILIALCAMPUS");
        console.log(this.offers);
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error = response.data.error;
        }
      })
      .finally(() => {
        this.$vs.loading.close();
      });
  },
  methods: {
    async selectOffer(offer) {
      updateStepsInformation({
        offerSimulate: offer,
        offerAttendance: "Selecionou Oferta: " + offer.CIDADE + ' - ' + offer.FILIALCAMPUS + ' - ' + offer.TURNO
      });
      this.$router.push("/simulate/tax");
    },

    formatShift({ TURNO: shift, MODALIDADE: type }) {
      if (type === "D") {
        return "A DISTÂNCIA";
      }
      return shift.trim().split(" ")[0];
    },
  },
};
</script>

